import { getPresets } from 'common/api/v1/systems';

import {
    FETCH_PRESETS,
    FETCH_PRESETS_FAILURE,
    FETCH_PRESETS_SUCCESS,
} from '../actionTypes';
import { actions } from '../reducer';

export default () => (dispatch) => {
    dispatch(actions[FETCH_PRESETS]());

    getPresets()
        .then((response) =>
            dispatch(actions[FETCH_PRESETS_SUCCESS](response.data.data)),
        )
        .catch((error) =>
            dispatch(
                actions[FETCH_PRESETS_FAILURE](error?.response?.data?.errors),
            ),
        );
};
